import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPropertyState } from "./propertyModel";
import {
  getAllActiveProperties,
  getAllPropertiesWithGalleryAndFAQ,
  getPropertyByURL,
} from "./services/property.services";

const initialState: IPropertyState = {
  loading: false,
  error: "",
  PropertyList: [],
  PropertyWithGalleyAndFAQList: [],
  PropertyDetails: {},
};

const propertySlice = createSlice({
  name: "property",
  initialState,
  reducers: {
    clearPropertyList: (state) => {
      state.PropertyList = initialState.PropertyList;
    },
    clearPropertyDetails: (state) => {
      state.PropertyDetails = initialState.PropertyDetails;
    },
    setPropertyDetails: (state, action: PayloadAction<any>) => {
      state.PropertyDetails = action.payload;
      state.loading = false;
    },
    setPropertyList: (state, action: PayloadAction<any[]>) => {
      state.PropertyList = action.payload || [];
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllActiveProperties.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveProperties.fulfilled,
      (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.PropertyList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveProperties.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PropertyList = [];
    });
    builder.addCase(getPropertyByURL.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getPropertyByURL.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.PropertyDetails = action.payload;
      },
    );
    builder.addCase(getPropertyByURL.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.PropertyDetails = state.PropertyDetails;
    });

    builder.addCase(getAllPropertiesWithGalleryAndFAQ.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllPropertiesWithGalleryAndFAQ.fulfilled,
      (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.PropertyWithGalleyAndFAQList = action.payload || [];
      },
    );
    builder.addCase(
      getAllPropertiesWithGalleryAndFAQ.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
        state.PropertyWithGalleyAndFAQList = [];
      },
    );
  },
});

export const {
  clearPropertyList,
  clearPropertyDetails,
  setPropertyDetails,
  setPropertyList,
} = propertySlice.actions;
export default propertySlice.reducer;
